<template>
  <div class="our-celebration page">
    <tabs>
      <tab
        name="Mehndi"
        date="Cancelled"
        :time="'Cancelled'"
        :location="'Canmore Ranch'"
        :events="['Dinner', 'Server', 'Family &amp; Friends Photos']"
        :selected="true"
        class="mehndi-area"
      >
        <h2 class="h2 melinda center">
          The Mehndi
        </h2>
        <p class="p">
          is a pre-wedding celebration in Ismaili culture and it is the ritual
          that kicks off the wedding festivities! It is a ceremony intended to
          unite both families. The evening is filled with laughter, dance,
          music, and lots of food in which all family members and friends
          participate.
        </p>
        <p class="p">
          During the evening, a professional henna artist applies mehndi onto
          the legs of the bride. The mehndi continues to remain on the hands and
          legs of the bride all night to ensure it comes out darker for her
          wedding day, as legend has it that "the darker the mehndi, the deeper
          the love." Henna artists are also available throughout the evening to
          apply mehndi for guests attending the event, too!
        </p>
        <h2 class="h2 melinda">
          Mandvho
        </h2>
        <p class="p">
          Four men are chosen from both sides of the family to protect the bride
          and groom as they journey through marriage. The men stand at four
          corners as a symbolic gesture of pillars and protection for the bride
          and groom.
        </p>
        <h2 class="h2 melinda">
          Celebrating the bride
        </h2>
        <p class="p">
          Equally, four women are chosen by the groom's mother. The bride walks
          under an embroidered cloth, which symbolizes protection.
        </p>
        <p class="p">
          The bride is first adorned with a set of jewellery by the groom’s
          mother and sister, which she wears for the evening, and passes down to
          her children.
        </p>
        <h2 class="h2 melinda">
          To welcome the groom
        </h2>
        <p class="p">
          Equally The bride's mother gifts the groom a piece of jewellery to
          welcome him into the family.
        </p>
        <h2 class="h2 melinda">
          Khobo
        </h2>
        <p class="p">
          This is led by the groom's father, where he carries a plate of coins.
          The bride is intended to grab as many coins as possible, as this
          symbolizes the couple’s prosperity. Therefore, the more coins she
          gets, the more prosperous she and the groom's life will be together.
        </p>
        <h2 class="h2 melinda center">
          Speeches
        </h2>
        <p class="p">
          Groomsmen + Bridesmaid
        </p>
        <h2 class="h2 melinda center">
          Family Photos
        </h2>
        <p class="p">
          We would be delighted if our guests could join us and the photographer
          for Family &amp; Friends photos at the Mehndi ceremony.
        </p>
        <h2 class="h2 melinda center">
          Lighting the Fire
        </h2>
        <p class="p">
          One of the first things the bride and groom ever did together was to
          light a fire at a mutual friend's birthday.
        </p>
        <p class="h2 melinda center">
          The Bride's Pithi &amp; The Groom's Vadaw
        </p>
        <p class="p">
          The Bride's Pithi is performed by women. The bride is given a sip of
          sherbet and a sweet, followed by well wishes and the rubbing of the
          pithi paste onto the bride's hands and legs. The paste is made out of
          chickpea flour, turmeric, sandalwood powder, herbs, aromatic oils,
          rose water and other ingredients. The paste is believed to be an
          excellent cleanser and provides soft and glowing skin for her special
          day.
        </p>
        <p class="p">
          The Groom's Vadaw is a joyful, playful and fun occasion in which
          family members and friends bless the groom as they did for the bride
          with sherbet and sweets.
        </p>
        <p class="p">
          However, unlike the bride.....he doesn't get any paste...What he gets
          is a lot messier and much more entertaining. Definitely one of those
          things you have to see to believe.... Traditionally a bribe is paid to
          the groom's sister (which is used to support the newlyweds with their
          new home) by the men and women to cover the groom with eatable treats.
          This is both a test and a reminder to the groom to put his family's
          needs before his own. So we ask everyone to participate in welcoming
          Christopher Garland Long to married life Asian-East African style.
          (Products will be provided)
        </p>
        <p class="p">
          All celebrations will be brought together to make this a night to
          remember. Delicious East African food will be served during this
          event, along with drinks. Please come celebrate with the couple and
          kick off the wedding festivities!
        </p>
      </tab>
      <tab
        name="Wedding"
        date="3 August 2021"
        time="13:00"
        :location="'Canmore Ranch'"
        :events="['TBD', 'TBD', 'TBD']"
        class="wedding-area"
      >
        <p class="p">
          Dearest Family &amp; Friends,
        </p>
        <p class="p">
          We are a go! While the border has not opened up as much as we would
          like we are pressing ahead with a smaller celebration of around 50
          guests.
        </p>
        <p class="p">
          Our wedding ceremony will begin at 13:00 on the 3rd of August at
          Canmore Ranch. Please see the google maps link below for the location.
          After we are wed below the Three Sister’s mountain appetizers and
          drinks will be served.
        </p>
        <p class="p">
          Following the ceremony there will also be music, a toast and photos
          with friends and family. We hope that you will enjoy the beautiful
          open space and surroundings. Please also note that the ceremony will
          be unplugged so please put away your phones and cameras and enjoy this
          special moment with us 😊.
        </p>
        <p class="p">
          <a
            href="https://www.google.com/maps/place/Canmore+Ranch/@51.0794066,-115.3482622,15z/data=!4m5!3m4!1s0x5370c5b7672a5173:0xb2dbd5fbfde94a17!8m2!3d51.0778664!4d-115.341782"
            target="_blank"
          >
            Google map - Canmore Ranch
          </a>
        </p>
      </tab>
      <tab
        name="Reception"
        date="3 August 2021"
        time="17:30"
        :location="'Cornerstone Theatre'"
        :events="['TBD', 'TBD', 'TBD']"
        class="reception-area"
      >
        <p class="p">
          Join us for our wedding reception at the Cornerstone Theater
          (Cornerstone Weddings) following our ceremony. Please see the link
          below for the location. We are excited to celebrate an intimate dinner
          with our (local) nearest and dearest and cocktails will be served at
          17:30 followed by dinner at 18:00.
        </p>
        <p class="p">
          The theater is walking distance from the center of Canmore and many of
          the hotels that we have suggested in the accommodation tab above. We
          will enjoy food, drinks, cake and dancing until 22:00!
        </p>
        <p class="p">
          <a
            class="reception-link"
            href="https://www.google.com/maps/place/Cornerstone+Weddings/@51.0864157,-115.3455555,17z/data=!3m1!4b1!4m5!3m4!1s0x5370c5bc183a7f41:0x8c9af57739c9eaaa!8m2!3d51.0863766!4d-115.3434638"
            target="_blank"
          >
            Google map - Cornerstone Theater
          </a>
        </p>
      </tab>
    </tabs>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";

export default {
  name: "OurCelebration",
  components: {
    Tabs,
    Tab
  }
};
</script>

<style lang="scss">
.celebration-nav {
  display: flex;
  flex: 1;
}

.nav-item {
  flex: 1;
  text-align: center;
  margin: 30px 0 60px;
}

.mehndi-area {
  padding: 30px 20px 20px 20px;
  background: #f7f7f7;
  color: #333;
}

.wedding-area {
  padding: 30px 20px 20px 20px;
  background: #8e8e8e;
  color: #f7f7f7;
}

.melinda {
  font-family: "melinda";
}

.center {
  text-align: center;
}

.reception-area {
  padding: 30px 20px 20px 20px;
  background: #333;
  color: #fff;
}

.reception-link {
  color: #8e8e8e;
}
</style>
